var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('a-spin',{staticClass:"chart"}):_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option,"autoresize":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }